<template>
  <div class="link-modal">
    <div class="link-modal__title">Link</div>

    <label class="link-modal__input">
      <div class="link-modal__link-wrapper">
        <span class="link-modal__url">{{name}}</span>
      </div>
    </label>

    <div class="link-modal__controls">

      <button class="link-modal__button link-modal__button_submit"
              @click.prevent="close()">
        Close
      </button>
    </div>
  </div>
</template>

<script>
import BaseModalMixins from '@/common/BaseModalMixins'

/**
 * Popup to display link data
 */
export default {
  name: 'LinkPopup',
  mixins: [BaseModalMixins],
  props: ['link'],

  computed: {
    name () {
      return this.link.name
    }
  },
  methods: {
    close () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
  .link-modal {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 40px;

    &__title-wrapper {
      display: flex;
      justify-content: space-evenly;
      height: 60px;
    }

    &__title {
      text-align: center;
      font-size: 34px;
      font-weight: 500;
      margin: 9px 0 35px;
      color: $rfx-dark-march;
    }

    &__input {
      display: flex;
      flex-direction: column;
      position: relative;

      &_invalid[type='text'] {
        border: 1px solid $rfx-red;
        border-radius: 4px;
      }
    }

    &__label {
      display: block;
      font-weight: 600;
      margin-bottom: 5px;
      color: $rfx-dark-march;
    }

    &__controls {
      display: flex;
      justify-content: flex-end;
      margin-top: 30px;
    }

    &__link-icon {
      font-size: 1.5em;
      color: $rfx-dark-march;

      &:hover {
        color: $rfx-bright-turquoise;
      }
    }

    &__button {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 900;
      text-transform: uppercase;
      margin-left: 30px;
      border: none;
      outline: none;
      cursor: pointer;

      &_submit {
        background-color: $rfx-medium-march;
        color: #fff;

        &:disabled {
          pointer-events: none;
          background-color: #fff;
          color: $rfx-neutral-grey;
          cursor: default;
        }
      }

      &_disabled {
        pointer-events: none;
        background-color: #fff;
        color: $rfx-neutral-grey;
        cursor: default;
      }

      &_cancel {
        color: $rfx-dark-march;
        background-color: #fff;
      }
    }

    &__link {
      &-wrapper {
        border: 2px solid $rfx-light-steel;
      outline: none;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 600;
      color: $rfx-dark-march;
      padding: 15px;
      position: relative;
      }

      &-field[type='text'] {
        width: 100%;
        box-sizing: border-box;
        padding-right: 60px;
        font-weight: 500;
        @include ellipsis;
      }
    }

  }

</style>
